import Button from "./ButtonAndLink/ButtonAndLink.svelte";
import Badge from "./ButtonAndLink/Badge.svelte";
import Modal from "./Modal.svelte";
import Textfield from "./Textfield.svelte";
import Textarea from "./Textarea.svelte";
import Label from "./Label.svelte";
import RadioGroup from "./RadioGroup.svelte";
import SelectCountry from "./SelectCountry.svelte";
import Select from "./Select.svelte";
import Icons from "./Icons";

const Link = Button;

export { Link, Button, Modal, Icons, Badge, Textfield, Textarea, Label, RadioGroup, SelectCountry, Select };
